import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, AfterViewChecked } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';
import * as moment from 'moment';
import * as fileSaver from 'file-saver';

import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { BufferChangeHistory } from 'app/buffer-graph/models/buffer-change-history/buffer-change-history';
import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column';
import { Formatters } from 'app/slick-grid/models/formatters';
import { OnDropdownFilteredEventArgs } from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import { DropdownFilterType } from 'app/slick-grid/interfaces/dropdown-filter-type';
import { EventArgs } from 'app/slick-grid/models/event-args';
import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import {CustomFunctionReturn} from "../../../slick-grid/models/custom-function-return";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";

@Component({
    selector: 'buffer-change-history',
    templateUrl: './buffer-change-history.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './buffer-change-history.component.css']
})
export class BufferChangeHistoryComponent extends TabComponentBase<BufferChangeHistory, { columns: { header: string, field: string }[], mainRows: any[] }> implements AfterViewChecked {
    constructor(graphService: BufferGraphService, exchangeService: BufferGraphDataExchangeService, translateService: TranslateService, renderer: Renderer2, elementRef: ElementRef){
        super(graphService, exchangeService, translateService, renderer, elementRef);

        this.showAllData = new EventEmitter<void>();

        this.dataView = new Slick.Data.DataView<BufferChangeHistory>();
        this.dataView.onRowsChanged.subscribe(() => this.setMainGridSellStyles());
        this.options = {syncColumnCellResize: true, multiColumnSort: true, editable: false};
        this.generateColumns = true;
        this.translateService.get('BufferChangeHistory').subscribe(t => this.mainRowsSheetName = t)
    }

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    protected isActive: boolean;

    @Input()
    private allShown: boolean;

    private data: BufferChangeHistory[];

    @Input()
    private set changes(changes: BufferChangeHistory[]) {
        this.data = changes;

        this.dropdownFilters = [];

        this.dataView.beginUpdate();
        this.dataView.setItems(changes);
        //this.dataView.setFilter(o => this.filterChangeHistory(o));
        this.dataView.endUpdate();
    }

    @Input()
    protected sku: string;

    @Input()
    protected warehouseCode: string;

    @Input()
    protected canSend: boolean;

    @Output()
    private readonly showAllData: EventEmitter<void>;

    private dropdownFilters: OnDropdownFilteredEventArgs<BufferChangeHistory>[];

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# show all data foe tab (not use)
    private onShowAllClick = (): void => {
        if (this.allShown)
            return;

        this.showAllData.emit();
    }

    //# download excel
    private onDownloadClick = (): void => {
        const fileName = `BufferHistory_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.graphService.downloadBufferChangeHistory(data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName)
            .map(file => { return { fileContent: file, fileName }; }));
    }

    //# send excel to email
    private onSendClick = (): void => {
        this.sendToEmail(data => this.graphService.sendBufferChangeHistory(this.tab.itemInfo.sku, this.tab.itemInfo.warehouseCode, data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName));
    }

    //private onHideExportErrorClick = (): void => {
    //    setTimeout(() => this.showExportError = false, 500);
    //}

    //private onHideSendErrorClick = (): void => {
    //    setTimeout(() => this.showSendError = false, 500);
    //}

    //private onHideSendSuccessClick = (): void => {
    //    setTimeout(() => this.showSendSuccess = false, 500);
    //}

    //set filter on grid
    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }

        this.dataView.setFilter(o => this.gridRef.filterHelper.filter(o));
    }

    private onGridFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<BufferChangeHistory>>): void => {
        //this.gridRef.filterHelper.onGridFiltered(args, type);
        //this.dataView.refresh();
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/buffer-change-history.component/buffer-change-history.component.ts